import { render, staticRenderFns } from "./Renewal.vue?vue&type=template&id=bcc66fbc&scoped=true&"
import script from "./Renewal.vue?vue&type=script&lang=js&"
export * from "./Renewal.vue?vue&type=script&lang=js&"
import style0 from "./Renewal.vue?vue&type=style&index=0&id=bcc66fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc66fbc",
  null
  
)

export default component.exports